import { environment } from 'src/environments/environment';

export const alertListMapping = {
  alert: {
    types: [
      {
        name: 'Activity',
        type: 'ACTIVITY_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Activity.jpg',
      },
      {
        name: 'Container',
        type: 'WAREHOUSE_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Container.jpg',
      },
      {
        name: 'Device',
        type: 'XSENSE_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Device.jpg',
      },
      {
        name: 'Equipment',
        type: 'EQUIPMENT_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentTaskReceived',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentGeofencingIn',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentGeofencingOut',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentTaskSend',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Equipment.jpg',
      },
      {
        name: 'Load',
        type: 'LOAD_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Load.jpg',
      },
      {
        name: 'Memo',
        type: 'DATE_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Memo.jpg',
      },
      {
        name: 'AndOr',
        type: 'ANDOR',
        imgUrl: environment.publicAssetsUrl + 'alert/type/AndOr.jpg',
      },
      {
        name: 'Satellite',
        type: 'SATELLITE_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/satellite.jpg',
      },
      {
        name: 'Irrigation',
        type: 'IRRIGATION_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Irrigation.jpg',
      },
      {
        name: 'Disease',
        type: 'DISEASE_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Disease.jpg',
      },
      {
        name: 'Insects',
        type: 'INSECTS_ALERT',
        imgUrl: environment.publicAssetsUrl + 'alert/type/Insects.jpg',
      },
    ],
  },
};
